export default __webpack_public_path__ + "static/media/saathi.b584e436.png";